<div
  class="mbs-page"
  [ngClass]="pageClass()">
  <div
    class="mbs-page_content"
    [class.pb-0]="flexMode()"
    [ngClass]="contentClass()">
    @if (showCustomErrorPage()) {
      <ng-content select="[custom-error]"></ng-content>
    } @else if (showErrorPage()) {
      <div class="mt-3">
        <mbs-alert-container></mbs-alert-container>
      </div>
      <div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center">
        <mbs-something-went-wrong (refresh)="refresh.emit()"></mbs-something-went-wrong>
      </div>
    } @else {
      <div [class.mt-3]="hasTopOffset()">
        <mbs-alert-container></mbs-alert-container>
        <ng-content select="[fixed-header]"></ng-content>
      </div>
      <div class="d-inline-flex flex-fill">
        <ng-content select="[content]"></ng-content>
      </div>
    }
  </div>
  <ng-content select="[footer]"></ng-content>
</div>
